<script lang="ts" setup>
import localizedFormat from "dayjs/plugin/localizedFormat";
import type { Connection } from "~/models/Connection";
import { useDayjs } from "#imports";

const props = defineProps<{
    noLabel?: boolean;
    small?: boolean;
    connection: Connection;
    grow?: boolean;
}>();

const dayjs = useDayjs();
dayjs.extend(localizedFormat);

const timeline = computed(() => {
    return (
        props.connection?.provisioning_metadata?.items.map((item) => ({
            value: item,
            timestamp: dayjs(item.timestamp).format("LTS"),
        })) ?? []
    );
});
</script>

<template>
    <div v-if="connection?.provisioning_metadata" class="relative" @click.stop>
        <div class="div px-4 py-3 text-left text-sm text-gray-900">
            <h4 v-if="!noLabel" class="font-medium font-display text-base">
                Data Sync Timeline
            </h4>
            <p
                class="opacity-50"
                :class="{
                    'mt-1': !noLabel,
                    'text-xs': small,
                }"
            >
                {{
                    dayjs(connection.provisioning_metadata.started_at).format(
                        "LLL",
                    )
                }}
                -
                {{
                    dayjs(connection.provisioning_metadata.finished_at).format(
                        "LLL",
                    )
                }}
            </p>
        </div>
        <UTable
            v-if="timeline.length"
            :ui="{
                thead: 'hidden',
                divide: 'max-w-full',
            }"
            :rows="timeline"
            class="overflow-y-auto overflow-x-hidden"
            :class="{
                'max-h-48 max-w-3xl': !grow,
                'w-full h-full': grow,
            }"
        >
            <template #value-data="{ row }">
                <div
                    class="flex flex-col text-balance overflow-hidden max-w-64 text-hd-primary-950"
                >
                    <span class="w-64">{{ row.value.message }} </span>
                </div>
            </template>
            <template #timestamp-data="{ row }">
                <span class="text-right opacity-75 block truncate">{{
                    row.timestamp
                }}</span>
            </template>
        </UTable>
    </div>
</template>
